import { environment } from '@environments/environment';

export enum Messages {
  OK = 'Ok',
  NO = 'No',
  YES = 'Yes',
  DELETE = 'Delete',
  MAILCHIMP = 'Mailchimp',
  KLAVIYO = 'Klaviyo',
  BREVO = 'Brevo',
  SUCCESS = 'success',
  CLOSE = 'close',
  SENDINBLUE = 'sendinblue',
  // API_KEY = 'API Key',
  MAILCHIMP_API_KEY = 'Enter Mailchimp API Key',
  BREVO_API_KEY = 'Enter Brevo API Key',
  SOMETHING_WENT_WRONG = 'Something went wrong',
  SHARE_INFO = 'Share Information',
  STOP_SHARING_INFO = 'Stop Sharing Information',
  SHARE_INFO_BODY = 'Would you like to share your information with [name] to be alerted to new content and exclusive opportunities?',
  STOP_SHARING_INFO_BODY = 'Are you sure you want to stop sharing your information with [name]?',
  INTERNET_CONNECTION_ERROR = 'No Internet Connection. Please check',
  SLOW_INTERNET_CONNECTION_ERROR = 'Upload failed due to slow internet. Please try again with a stable connection.',
  UPLOAD_SUCCESS = 'uploaded successfully',
  INVALID_FILE_TYPE = 'Cannot upload this file. The format is not supported',
  SUBCATEGORY_EMPTY = `Seems like selected category(s) don't have subcategory(s)`,
  LOGO_REQUIRED = 'Please upload logo.',
  SELECTE_SOURCE_TYPE = 'Please select source type and amount',
  SELECT_AMMOUNT = 'Please select amount',
  START_DATE = 'From date should be greater than to date',
  END_DATE = 'TO date should be greater than start date',
  MIN_AMMOUNT = 'Maximum amount should be $1000',
  min_age_required = 'Min age is required',
  max_age_required = 'Max age is required',
  min_age_message = 'Min age cannot be greater than max Age',
  Radius = 'Radius is required',
  Min_Radius = 'Min radius cannot be less than 10',
  One_FieldREquired = 'Please select atleast one subscription package or one merchandise',
  requiredGender = 'Atleast one gender is required',
  Location = `Location can't be blank`,
  noDataFound = 'Searched data not found',
  saveFilter = 'Segment Filter saved successfully',
  userFetchSuccess = 'User Segmentation Successful',
  emailSendSuccess = 'Emails sent successfully',
  msgSendSuccess = 'SMS Text Messages sent successfully',
  audioFileSizeLimit = 'File size cannot be greater than 50 MB',
  imageFileSizeLimit = 'File size cannot be greater than 5 MB',
  pollImageFileSizeLimit = 'File size cannot be greater than 5 MB',
  GEO_LOCATION_ALERT = `Location Permission Denied! Please be aware that certain features and functionalities within this application may be limited or disabled.
        To allow location, please click the lock icon next to the URL.`,
  LABEL_TO_TAKE_TO_YOUR_VIP_OFFERS = 'You can change label on the button that takes fans to your VIP offers (i.e., it can say Deals or Special Offers)',
  ACTIVATING_OFFER = 'Activating this offer will make it visible to your fans. Are you sure you want to proceed?',
  INACTIVATING_OFFER = 'Disabling this offer will remove it from being seen by your fans. Are you sure you want to proceed?',
  FIRST_NAME_REQUIRED = ' * Enter First Name',
  MAIL_CHIMP_INFO = 'To export and send your followers in this segment to your Mailchimp account, you need to first create an API key in Mailchimp and enter it into TopFan. To create an API key in Mailchimp, login to your account and then click the “Create A Key” button on this page:\n <a class="hyperlink" href="https://admin.mailchimp.com/account/api/" target="_blank" rel="noopener noreferrer">https://admin.mailchimp.com/account/api/</a>',
  KLAVIYO_INFO = 'To export and send your followers in this segment to your Klaviyo account, you need to first acquire a Public API Key and a Private API Key from Klaviyo. To find both your Public API Key and create a Private API Key, login to your Klaviyo account and then visit this page:\n <a class="hyperlink" href="https://www.klaviyo.com/settings/account/api-keys" target="_blank" rel="noopener noreferrer">https://www.klaviyo.com/settings/account/api-keys</a>',
  BREVO_INFO = 'To export and send your followers in this segment to your Brevo account, you need to first create an API Key in Brevo. To create an API key in Brevo, login to your account and then visit this page: \n\n<a class="hyperlink" href="https://app.brevo.com/settings/keys/api" target="_blank" rel="noopener noreferrer">https://app.brevo.com/settings/keys/api</a>',
  VALID_FIRST_NAME_REQUIRED = '* Enter a valid First Name',
  LAST_NAME_REQUIRED = ' * Enter Last Name',
  VALID_LAST_NAME_REQUIRED = ' * Enter a valid Last Name',
  ONLY_FOLLOWERS_TOGGLE_INFO = 'If you enable this option, fans must first follow you before seeing your content on your profile on TopFan.com. However, if you choose to make specific videos, reels and photos available to be shown on your Link in Bio or Discovery Feed, those posts will be visible there. You can also setup an automated welcome direct message to your new followers on <a class="hyperlink" href="https://www.topfan.com/" target="_blank" rel="noopener noreferrer">TopFan.com</a> in Messages. <br><br>Note:  All users will see your content on your white-label site as users can only “Follow” you on <a class="hyperlink" href="https://www.topfan.com/" target="_blank" rel="noopener noreferrer">TopFan.com</a> (unless you make your account private).',
  MAKE_ACCOUNT_PRIVATE = 'If you make your Account Private, fans will need to request your permission to able to see your content and interact with you. Those requests will show in Follow Requests inside the Activity Section. ',
  MAXIMUM_100_NAME_ALLOWED = '* Maximum 100 characters allowed.',
  VENUE_NAME_IS_REQUIRED = '* venue Name is required',
  SELECT_COUNTRY = '* Select Country',
  START_TIME_REQUIRED = '* Starting Time Required',
  TIMEZONE_REQUIRED = '* TimeZone is Required',
  COUNTRY_REQUIRED = '* Select Country',
  STATE_REQUIRED = '* Select State',
  DIRECTION_TO_VENUE = 'If you include the street address , your fans can get direction to the venue.',
  MAXIMUM_1000_CHARACTER_ALLOWED = '* Maximum 1000 characters allowed.',
  UPDATE = 'Update',
  CANCEL = 'Cancel',
  CONFIRM = 'Confirm',
  PROVIDE_MORE_INFO = "Provide anything else you'd like the fans to know include hyperlinks...",
  PROVIDE_STREET_ADDRESS = 'If you include the street address , your fans can get direction to the venue.',
  BUTTON_LABEL = 'You can change label on the button that takes fans to your Event Ticketing (i.e., it can say Tour Dates or Competitions)',
  CHATROOM_BUTTON_LABEL = 'You can change label on the button that takes fans to your Chat Room (i.e., it can say Community or Fan Chat)',

  SUBSCRIPTION_PLAN_REQUIRED_MSG = 'You need a subscription to enable this setting.',
  INVALID_FORMAT_CSV = 'Cannot upload this file. Please check sample CSV file.',
  CSV_CONTAINS_COMMA = 'The uploaded file contains comma. Please check sample CSV file.',
  EMPTY_FILE = 'The uploaded CSV file is empty.',
  UNIQUE_CODE_REQUIRED = 'Unique code is required',
  CODE_IMPORT_SUCCESS = 'Code Import Successful',
  UNIQUE_CODE_IMPORTED_SUCCESS = 'Your upload was completed. <code-length> unique codes have been imported into the bank for this offer',
  DUPLICATE_CODE_REJECTED = 'Note: <code-length> code were rejected and not able to be imported. You can review the Unique Code Bank to see which codes were imported and/or assigned',
  UNIQUE_CODE_IMPORTED = 'unique codes have been imported successfully.',
  REJECTED_IMPORTS = 'Rejected imports:',
  INTERNET_LOST = 'You have lost internet connection',
  UNIQUE_CODE_BANK = 'Unique Code Bank',
  CODE_ISSUED = 'Codes Issued',
  CODE_LEFT = 'Codes Left',
  DOWNLOAD = 'Download',
  MULTIPLE_OFFER_LOCK_WITH_FREE_ERROR = "Multiple offer lock can't be selected with free offer",
  OFFER_CONFIG_SET_MSG = 'Please add an Active Offer to Enable Displaying VIP Offers on your TopFan site',
  PHONE_NUMBER_NOT_FOUND_FOR_SEGMENTED_USERS = 'None of the qualifying segmented users are accepting SMS text messages.',
  EMAIL_NUMBER_NOT_FOUND_FOR_SEGMENTED_USERS = 'None of the qualifying segmented users are accepting emails.',
  INVALID_FILE = 'Invalid file format',
  VIP_OFFER_NOW_ACTIVE = 'VIP Offers are now displaying on your TopFan site',
  VIP_OFFER_NOW_IN_ACTIVE = 'VIP Offers are disabled on your TopFan site',
  EVENT_NOW_ACTIVE = 'Events are now displaying on your TopFan site',
  EVENT_NOW_IN_ACTIVE = 'Events are disabled on your TopFan site',
  NO_VIP_OFFER_FOUND = 'You have not added any VIP Offers yet.',
  NO_VIP_OFFER_ACTIVE = 'No VIP Offers are Inactive',
  VIP_OFFERS_CAPS = 'VIP OFFERS',
  MY_EVENTS = 'Events',
  BTN_LABEL_UPDATED_SUCCESS = 'Button label updated successfully.',
  EVENT_HEADING_UPDATED_SUCCESS = 'Event heading updated successfully.',
  CHATROOM_MESSAGE_UPDATED = 'Chat Room message updated successfully.',
  BTN_LABEL_IS_EMPTY = "Button label can't be empty",
  SELECT_SUBSCRIBERS_FOR_FREE_COURSE = 'Select which Subscribers can Access Course for Free',
  SELECT_SUBSCRIBERS_FOR_FREE_NEWSLETTER = 'Select which Subscribers can Access Newsletter for Free',
  SELECT_SUBSCRIBERS_FOR_FREE_DOWNLOADABLE = 'Select which Subscribers can Access Downloadable for Free',
  SELECT_SUBSCRIBERS_FOR_FREE_VIP_OFFER = 'Select which Subscribers can Access VIP Offer for Free',
  ALLOW_NFT_FOR_FREE_COURSE = 'Allow NFT Holders to Access Course for Free',
  ALLOW_NFT_FOR_FREE_NEWSLETTER = 'Allow NFT Holders to Access Newsletter for Free',
  ALLOW_NFT_FOR_FREE_DOWNLOADABLE = 'Allow NFT Holders to Access Downloadable for Free',
  ALLOW_NFT_FOR_FREE_VIP_OFFER = 'Allow NFT Holders to Access VIP Offer for Free',
  ADD_NFT_ADDRESS = 'Add NFT Contract Address',
  UNLOCK_GIVEAWAY = 'You need to unlock the post to unlock giveaways.',
  BANDISTOWN_SYNCED_SUCCESS = 'Bandsintown data synced successfully',
  PAY_TO_UNLOCK = 'Pay to unlock',
  COVER_UPDATED_SUCCESSFULLY = 'Cover image updated successfully',
  CHATROOM_UPDATED_SUCCESSFULLY = 'Chat Room image updated successfully',
  PROFILE_IMAGE_NOT_SELECTED = 'Please Upload your Profile Photo',
  PROFILE_AVATAR_NOT_SELECTED = 'Please Upload a Profile Avatar Image',
  BANNER_IMAGE_NOT_SELECTED = 'Please Upload a Banner Image',
  DISPLAYED_CREATOR_NAME_ALREADY_TAKEN = 'This Public Profile URL is already taken',
  PROVIDE_ATLEAST_ONE_HANDLE = 'You need to provide at least one Social Media Handle',
  REQUIRED_FIELDS = 'Please fill all the required fields',
  VERIFF_SDK_NOT_AVAILABEL = 'veriffSDK is not available',
  USER_PROFILE_UPDATED = 'User Profile Updated',
  MOBILE_PHONE_NUMBER_INFO_MESSAGE = 'By providing your Mobile Phone Number, you will be able to receive SMS text messages from creators you interact with about their new content and special offers. You can opt out of text messages for individual creators in your Privacy & Password preferences.',
  ALLOW_BASIC_INFO_TO_SHARE = 'These settings will determine if the creator has access to your age, gender, email, mobile phone, shipping address, in order to provide content and merchandise to you. You can edit the notifications you receive from the creator in Preferences > Notifications & Newsletters.',
  INSUFFICIENT_VIP_CODES = 'The number of unique VIP Offer Codes is getting low. Once these run out, the Offer will be disabled for your fans. Please upload more codes to keep the offer active.',
  ADD_ANOTHER_NFT_ID = 'Add Another NFT ID',
  MUST_BE_ADULT_TO_VIEW_CONTENT = 'You must be 18 years or older to view this content.',
  UPDATE_EMAIL_ADDRESS = 'Update Email Address',
  MAX_PRICE_MONETIZE_ITEMS_ERROR = '* Price must be between $1.00 and $10,000',
  LEGAL_FIRST_LAST_NAME_MESSAGE = 'Your Legal First and Last Name is not publicly displayed. If you need change your legal name, please contact Customer Support.',
  INVALID_GIF_DIMENSION_MESSAGE = 'GIF image dimensions must be 300x300 pixels or smaller.',
  ADD_WELCOME_VIDEO = 'Add a Profile Welcome Video',
  WELCOME_TO_MY_TOPFANS = 'Hi everyone, welcome to my fan community!',
  WELCOME_TO_NEW_FAN_COMMUNITY = 'Hi everyone, welcome to my new fan community!',
  WELCOME_MESSAGE_TITLE_DESC = 'Add a short 1-3 minute video to welcome fans to your TopFan site. This is where you can explain the benefits of becoming a Subscriber, and mention the other exclusive things you are offering including content, merchandise, experiences, downloadables, chat room and courses.',
  WELCOME_MESSAGE_NOTE = 'Your Welcome Video will show at the top of your feed to anyone who doesn’t already follow you. Once they follow you, your Welcome Video will still be accessible from your profile. You can update your Welcome Video at anytime to highlight what’s new in your offering.',
  DISABLE_WELCOME_MESSAGE = 'Your welcome message will no longer be visible to fans.',
  ENABLE_WELCOME_MESSAGE = 'Your welcome message will now be visible to fans.',
  DISABLED = 'Disabled',
  INDIVIDUAL_PURCHASE_PRICE = 'Individual Purchase Price',
  ACTIVATING_COUPEN = 'Activating this discount code will make it visible to your fans. Are you sure you want to proceed?',
  END_DATE_ACTIVATING_COUPON = 'To Activate this discount code, you must edit its end date to a future date.',
  INACTIVATING_COUPEN = 'Disabling this discount code will remove it from being seen by your fans. Are you sure you want to proceed?',
  NO_SUBSCRIBERS_FOUND = 'No subscribers found.',
  MONTHS = ' Months',
  MONTH = ' Month',
  INSERT_FIRST_NAME = '+ Insert First Name',
  SEND = 'Send',
  CURRENCY = 'Currency',
  ADD_LESSON = 'ADD LESSON',
  UNPUBLISH = 'Unpublish',
  PUBLISH = 'Publish',
  NEED_TO_ENABLE_EARN_POINTS = 'You need to enable Earn Points first.'
}

export enum Button {
  publishNow = 'Publish Now',
  updateNow = 'Update',
  saveAsDraft = 'Save as Draft',
  scheduleToPublishAndSend = 'Schedule to Publish and Send',
  Schedule = 'Schedule'
}
export enum UnlockedBy {
  Self = 'Self <content>',
  Subscription = '<content> unlocked with a subscription',
  Individual = '<content> unlocked with an individual price',
  NFT = '<content> unlocked with an NFT',
  LoyaltyPoints = '<content> Unlocked with Points'
}

export const MESSAGE_HINTS = {
  CURRENCY_CHANGE: `If you need to change your Currency, please contact <a href="${environment.websiteURL}help-faq" target="_blank" class="highlight">Customer Support</a>.`
};